angular.module('impactx.autocompleteselection').service('AutocompleteSelectionPanel', [
    '$mdPanel',
    '$q',
    AutocompleteSelectionPanel]);

function AutocompleteSelectionPanel($mdPanel, $q) {
    var self = this;
    var panelRef, defer, locals, transferData;

    self.openPanel = function (config) {
        if (config) {
            defer = $q.defer();
            locals = config.locals || {};
            var panelXPosition = config.xPosition || $mdPanel.xPosition.ALIGN_START;
            var panelYPosition = config.yPosition || $mdPanel.yPosition.BELOW;
            var panelXOffset = config.xOffset || 0;
            var panelYOffset = config.yOffset || 0;
            var target = config.target || config.event.target;

            var panelConfig = {
                attachTo: angular.element(document.body),
                controller: 'AutocompleteSelectionPanelCtrl',
                controllerAs: 'ctrl',
                zIndex: 100,
                locals: {
                    config: config
                },
                position: $mdPanel.newPanelPosition().relativeTo(target)
                    .withOffsetY(panelYOffset).withOffsetX(panelXOffset)
                    .addPanelPosition(panelXPosition, panelYPosition),
                panelClass: 'autocomplete-selection-panel',
                event: config.event || undefined,
                templateUrl: 'shared/autocompleteselection/templates/autocomplete-selection.panel.html',
                clickOutsideToClose: config.clickOutsideToClose || true,
                escapeToClose: config.escapeToClose || true,
                focusOnOpen: config.focusOnOpen || false,
                onDomRemoved: function () {
                    defer.reject();
                    panelRef.destroy();
                }
            };

            $mdPanel.open(panelConfig).then(function (result) {
                panelRef = result;
            });

            return defer.promise;
        }
        else {
            console.log('no config for autocomplete selection service provided!')
        }
    };

    self.closePanel = function () {
        defer.resolve(transferData);
        transferData = {};
        panelRef.close().then(function () {
            panelRef.destroy();
        });
    };

    self.setSelection = function (entry) {
        if (entry) {
            transferData = entry;
        }
    };

    return {
        openPanel: this.openPanel,
        closePanel: this.closePanel,
        setSelection: this.setSelection,
    };
}